export const serializeQuery = (query: { [key: string]: string | number } = { pagina: 1 }) => {
  return Object.keys(query)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(query[key])}`)
    .join('&');
};
